import createLucideIcon from '../createLucideIcon';

const ArrowUpFromDot = createLucideIcon('ArrowUpFromDot', [
  ['line', { x1: '12', x2: '12', y1: '16', y2: '2', key: '1nwqpu' }],
  ['polyline', { points: '5,9 12,2 19,9', key: '1i4oif' }],
  ['circle', { cx: '12', cy: '21', r: '1', key: 'o0uj5v' }],
]);

export default ArrowUpFromDot;
